/**
 * Result codes for 3DS authentication
 * Based on Adyen payment result codes
 */
export enum ThreeDSStatusCode {
  AUTHORISED = 'Authorised',
  REFUSED = 'Refused',
  PENDING = 'Pending',
  ERROR = 'Error',
  CANCELLED = 'Cancelled',
}

/**
 * Result of 3DS authentication
 */
export interface ThreeDSResult {
  status: ThreeDSStatusCode;
  data?: any;
  error?: any;
}

/**
 * Interface for 3DS handlers
 * Each payment gateway should implement this interface
 */
export interface ThreeDSHandler {
  /**
   * Handle 3DS authentication for a specific gateway
   *
   * @param payload The gateway-specific action payload (usually from gateway_payload)
   * @returns Promise that resolves with the 3DS result
   */
  handle(
    payload: string,
    submitCallback: (pspResults: any) => Promise<any>,
  ): Promise<ThreeDSResult>;
}
